import { ID, Response } from '@/_metronic/helpers'
import axios, { AxiosResponse } from 'axios'
import {
  TrxStatusData,
  TrxPaymodeData,
  TrxCarrierData,
  TrxMsisdnData,
  TrxEvolutionData,
  TrxIndicatorsData
} from './_models'

const BASE_URL = '/p2c/reports/payment'

interface IParams {
  from: Date;
  to: Date;
  userId?: ID;
  timezone: string;
}

// eslint-disable-next-line
const formatParams = (params?: Record<string, any>): Record<string, any> => {
  if (!params) return {};

  const formatted = Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');

        return [key, `${year}-${month}-${day}`];
      }
      return [key, value];
    })
  );

  return formatted;
};
/**

 * getTrxStatus.
 *
 * @returns {Promise<Array<TrxStatusData>>}
 */
export const getTrxStatus = async (params: IParams & { paymode?: string }): Promise<Array<TrxStatusData>> => {

  return axios
    .get(`${BASE_URL}/trx-status`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<TrxStatusData>>>) => d.data)
    .then((d: Response<Array<TrxStatusData>>) => d.data || [])
}

/**
 * getTrxIndicators.
 *
 * @returns {Promise<Array<TrxStatusData>>}
 */
export const getTrxIndicators = async (params: IParams & { paymode?: string }): Promise<TrxIndicatorsData> => {

  return axios
    .get(`${BASE_URL}/indicators`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<TrxIndicatorsData>>) => d.data)
    .then((d: Response<TrxIndicatorsData>) => d.data || { trx: 0, amount: 0, payout: 0 } as TrxIndicatorsData)
}


/**
 * getTrxPaymode.
 *
 * @returns {Promise<Array<TrxPaymodeData>>}
 */
export const getTrxPaymode = async (params: IParams): Promise<Array<TrxPaymodeData>> => {
  return axios
    .get(`${BASE_URL}/trx-paymode`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<TrxPaymodeData>>>) => d.data)
    .then((d: Response<Array<TrxPaymodeData>>) => d.data || [])
}

/**
 * getTrxCarrier
 *
 * @returns {Promise<Array<TrxCarrierData>>}
 */
export const getTrxCarrier = async (params: IParams & { paymode?: string }): Promise<Array<TrxCarrierData>> => {

  return axios
    .get(`${BASE_URL}/trx-carrier`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<TrxCarrierData>>>) => d.data)
    .then((d: Response<Array<TrxCarrierData>>) => d.data || [])
}

/**
 * getTrxMsisdn
 *
 * @returns {Promise<Array<MsisdnData>>}
 */
export const getTrxMsisdn = async (params: IParams & { paymode?: string }): Promise<Array<TrxMsisdnData>> => {

  return axios
    .get(`${BASE_URL}/trx-msisdn`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<TrxMsisdnData>>>) => d.data)
    .then((d: Response<Array<TrxMsisdnData>>) => d.data || [])
}

/**
 * getTrxEvolution.
 *
 * @returns {Promise<Array<TrxEvolutionData>>}
 */
export const getTrxEvolution = async (params: IParams & { paymode?: string, pad: string }): Promise<Array<TrxEvolutionData>> => {

  return axios
    .get(`${BASE_URL}/trx-evolution`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<TrxEvolutionData>>>) => d.data)
    .then((d: Response<Array<TrxEvolutionData>>) => d.data || [])
}
